import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { Search, XLg } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

function ProductSearchConfiguration(props) {
    const { t } = useTranslation('messages');

    let shopIds = props.shopList.map((shop) => shop.id);

    const handleSubmit = (e) => {
        e.preventDefault();
        props.fetchProducts();
    };

    return (
        <>
            {/* Shop toggles */}
            <div className="d-flex flex-wrap gap-2 mb-3">
                {props.shopList.map((shop) => (
                    <div key={shop.id}>
                        <input
                            type="checkbox"
                            className="btn-check"
                            id={`shop-${shop.id}`}
                            checked={props.checkedShops.includes(shop.id)}
                            onChange={(e) =>
                                checkShopCheckbox(
                                    e.target.checked,
                                    shop.id,
                                    shopIds,
                                    props.checkedShops,
                                    props.setCheckedShops,
                                    props.setSelectAllChecked
                                )
                            }
                            readOnly
                        />
                        <label className="btn btn-outline-light btn-sm" htmlFor={`shop-${shop.id}`}>
                            {shop.name}
                        </label>
                    </div>
                ))}
            </div>

            {/* Options row */}
            <Row className="mb-3 g-2 align-items-center">
                <Col xs="auto">
                    <Form.Check
                        type="switch"
                        id="only-available-switch"
                        label={t('main.store_search.checkbox_only_available')}
                        checked={props.onlyAvailableChecked}
                        onChange={(e) => props.setOnlyAvailableChecked(e.target.checked)}
                        className="text-white"
                    />
                </Col>
                <Col xs="auto">
                    <Form.Check
                        type="switch"
                        id="select-all-switch"
                        label={t('main.store_search.checkbox_all_shops')}
                        checked={props.selectAllChecked}
                        onChange={(e) => checkAllShops(e.target.checked, shopIds, props.setCheckedShops, props.setSelectAllChecked)}
                        className="text-white"
                    />
                </Col>
                <Col xs={12} sm="auto" className="ms-md-3" style={{ minWidth: '160px' }}>
                    <Form.Label className="text-white mb-1 small">
                        {t('main.store_search.label_max_results')}: <strong>{props.maxResults}</strong>
                    </Form.Label>
                    <Form.Range
                        min={1}
                        max={50}
                        step={1}
                        value={props.maxResults}
                        onChange={(e) => props.setMaxResults(Number(e.target.value))}
                    />
                </Col>
                <Col xs={12} sm="auto" style={{ minWidth: '160px' }}>
                    <Form.Label className="text-white mb-1 small">
                        {t('main.store_search.label_min_price')}: <strong>€{props.minPrice}</strong>
                    </Form.Label>
                    <Form.Range
                        min={0}
                        max={500}
                        step={1}
                        value={props.minPrice}
                        onChange={(e) => props.setMinPrice(Number(e.target.value))}
                    />
                </Col>
                <Col xs={12} sm="auto" style={{ minWidth: '160px' }}>
                    <Form.Label className="text-white mb-1 small">
                        {t('main.store_search.label_max_price')}: <strong>€{props.maxPrice}</strong>
                    </Form.Label>
                    <Form.Range
                        min={0}
                        max={500}
                        step={1}
                        value={props.maxPrice}
                        onChange={(e) => props.setMaxPrice(Number(e.target.value))}
                    />
                </Col>
            </Row>

            {/* Search field */}
            <Row>
                <Col xs={12} md={8} lg={6}>
                    <Form onSubmit={handleSubmit}>
                        <InputGroup size="lg">
                            <Form.Control
                                type="text"
                                value={props.searchValue}
                                placeholder={t('main.store_search.search_form_placeholder')}
                                onChange={e => props.setSearchValue(e.target.value)}
                                className="border-0"
                            />
                            {props.searchValue && (
                                <Button variant="outline-light" onClick={() => props.setSearchValue("")} tabIndex={-1}>
                                    <XLg size={14} />
                                </Button>
                            )}
                            <Button variant="light" type="submit" className="fw-semibold px-4">
                                <Search size={14} className="me-2" />
                                {t('main.store_search.search_form_button_text')}
                            </Button>
                        </InputGroup>
                    </Form>
                </Col>
            </Row>
        </>
    );
}

function checkShopCheckbox(checked, shopId, shopIds, checkedShops, setCheckedShops, setSelectAllChecked) {
    const checkedIndex = checkedShops.indexOf(shopId);

    if (checked && checkedIndex < 0) {
        checkedShops.push(shopId);
    } else if (!checked && checkedIndex >= 0) {
        checkedShops.splice(checkedIndex, 1);
    }
    setCheckedShops([...checkedShops]);

    if (shopIds.every(r => checkedShops.includes(r))) {
        setSelectAllChecked(true);
    } else {
        setSelectAllChecked(false);
    }
}

function checkAllShops(checked, shopIds, setCheckedShops, setSelectAllChecked) {
    setSelectAllChecked(checked);
    if (checked) {
        setCheckedShops([...shopIds]);
    } else {
        setCheckedShops([]);
    }
}

export default ProductSearchConfiguration;
